import { isLimitedAgent } from './roleAccess';

// Beta gate for Leads (the CRM) and Pipeline. Opened to the whole team (Kelly, Nov 3, 2026).
// true = only Admin users see it; everyone else sees "Coming soon".
export const CRM_ADMIN_ONLY = false;
// Hard block (Kelly): Amanda Bolduc never gets a Leads section or Pipeline. Matched by uid AND email (like
// youtubeStudio's HIDDEN_EMAILS) and also by the Limited Agent role, so a role change alone can't open it.
export const CRM_BLOCKED_UIDS = ['iMJkS06Cs6U9kXu7KwXuKotYdOz1'];
export const CRM_BLOCKED_EMAILS = ['amanda.bolduc@exprealty.com'];
export const isCrmBlocked = (userRole, uid = '', email = '') => isLimitedAgent(userRole)
  || CRM_BLOCKED_UIDS.includes(uid) || CRM_BLOCKED_EMAILS.includes(String(email || '').trim().toLowerCase());
export const canUseCrm = (userRole, uid = '', email = '') => !isCrmBlocked(userRole, uid, email) && (!CRM_ADMIN_ONLY || userRole === 'Admin');
